import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appIntegerOnly]',
})
export class IntegerOnlyDirective {
  private regex: RegExp = /^([1-9]|[1-9][0-9]|100)$/;

  constructor(private el: ElementRef) { }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Backspace' || event.key === 'Delete' || event.key === 'ArrowLeft' || event.key === 'ArrowRight' || event.key === 'Tab') {
      return; // Allow: backspace, delete, arrow left/right
    }

    const input = event.key;
    const value = this.el.nativeElement.value + input;

    if (!this.regex.test(value)) {
      event.preventDefault(); // Prevent invalid character input
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const pastedInput = event.clipboardData.getData('text/plain');
    if (!this.regex.test(pastedInput)) {
      event.preventDefault(); // Prevent pasting invalid input
    }
  }
}
